module.exports = __webpack_public_path__ + "static/media/br.a82efeaf.svg";